// extracted by mini-css-extract-plugin
module.exports = {"header_div":"facultyRoasterList_header_div__NORPW","buttonCustomStyles":"facultyRoasterList_buttonCustomStyles__1IKAH"};